export default {
  data: {
    actions: {},
  },
  methods: {
    bindData(actions) {
      this.actions = actions;
    },
    newCourse(action) {
      let url;
      if(action == 'clone'){
        url = Kadenze.Routes.new_course_create_actions_clone_path();
      } else if (action == 'import') {
        url = Kadenze.Routes.new_course_create_actions_import_path();
      } else if (action == 'new') {
        url = Kadenze.Routes.new_course_create_actions_new_course_path();
      } else if (action == 'move') {
        url = Kadenze.Routes.new_course_create_actions_move_path();
      } else {
        return window.location.href = '/courses/new?course[copy_action]='+action;
      }
      window.location.href = url;
    },
  },
};
